"use client";
import { useEffect, useRef, useState } from "react";
import * as THREE from "three";

export default function VantaWavesBackground() {
  const vantaRef = useRef<HTMLDivElement>(null);
  const [vantaEffect, setVantaEffect] = useState<any>(null);

  useEffect(() => {
    // Only import vanta on client side
    if (!vantaEffect && vantaRef.current) {
      import("vanta/dist/vanta.waves.min.js").then((WAVES) => {
        const effect = (WAVES as any).default({
          el: vantaRef.current,
          THREE: THREE,
          mouseControls: false,
          touchControls: false,
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          scale: 0.5,
          scaleMobile: 1.0,
          color: 0x19877c,        // Match your medium blue from gradient
          shininess: 0,           // Drastically reduce shininess (was 130)
          waveHeight: 40,         // Reduce wave height for subtlety (was 28.5)
          waveSpeed: 0.6,         // Slower, more gentle movement (was 0.5)
          zoom: 0.7,             // Zoom in slightly to fill space better (was 0.7)
        });
        setVantaEffect(effect);
      });
    }

    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [vantaEffect]);

  return (
    <div
      ref={vantaRef}
      className="fixed inset-0 w-full h-full z-0"
      style={{ opacity: 0.6, mixBlendMode: 'lighten' }}
    />
  );
}